import { Stack } from "@mui/material";
import { ReuseInput } from "components/ui";
import { Fields } from "./ProductDetailsModal";
import { memo } from "react";

type Props = {
  formData: Fields;
  errorMessage: Fields;
  inputChangeHandler: (field: string, value: string) => void;
  error: { [key: string]: boolean };
  setErrorHandler: (field: string, value: boolean) => void;
};

export const DescriptionBlock = memo(
  ({
    formData,
    inputChangeHandler,
    error,
    setErrorHandler,
    errorMessage,
  }: Props) => {
    return (
      <Stack gap="42px" pt="24px" pb="32px">
        <ReuseInput
          name="company_name"
          handleInputChange={inputChangeHandler}
          errorMessage={
            errorMessage.company_name ||
            "Must contain only letters, numbers, and basic punctuation"
          }
          value={formData.company_name || ""}
          label="Account Name *"
          maxLength={100}
          placeholder=" e.g., INFUSE"
          isError={error.company_name || !!errorMessage.company_name}
          setErrorHandler={setErrorHandler}
        />
        <ReuseInput
          name="product_name"
          handleInputChange={inputChangeHandler}
          errorMessage={
            errorMessage.product_name ||
            "Must contain only letters, numbers, and basic punctuation"
          }
          value={formData.product_name || ""}
          label="Product, Solution or Service Name *"
          maxLength={100}
          placeholder=" e.g., INFUSE"
          isError={error.product_name || !!errorMessage.product_name}
          setErrorHandler={setErrorHandler}
        />
        <ReuseInput
          name="product_abstract"
          handleInputChange={inputChangeHandler}
          errorMessage={
            errorMessage.product_abstract ||
            "This field is required and cannot include scripts."
          }
          value={formData.product_abstract || ""}
          label="Product, Solution or Service Description *"
          maxLength={1500}
          multiline={true}
          placeholder=" e.g., INFUSE is a global high-performance demand partner delivering demand strategies,
         programs, and outcomes for the most admired B2B brands"
          isError={error.product_abstract || !!errorMessage.product_abstract}
          setErrorHandler={setErrorHandler}
        />
      </Stack>
    );
  },
  (prevProps, nextProps) =>
    prevProps.formData === nextProps.formData &&
    prevProps.error === nextProps.error &&
    prevProps.errorMessage === nextProps.errorMessage,
);
